<template>
  <AppLayout>
    <section class="space-top space-bottom">
      <v-container>
        <v-row justify="center">
          <v-col style="max-width: 700px">
            <HtmlContent file="privacy"></HtmlContent>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </AppLayout>
</template>

<script>
import HtmlContent from "./components/HtmlContent";
import AppLayout from "../../layout/AppLayout/AppLayout";
export default {
  components: {
    HtmlContent,
    AppLayout,
  },
};
</script>
